import * as React from 'react';
export const playCircleSvg = React.forwardRef(function playCircleSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.875 4.074c0-.27.327-.419.556-.256l2.682 1.926a.308.308 0 0 1 0 .512L5.431 8.182c-.229.163-.556.014-.556-.256V4.074Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.31.008A5.994 5.994 0 0 1 12 6l-.008.309A6 6 0 0 1 6 12l-.309-.008A6 6 0 0 1 .008 6.31L0 6a6 6 0 0 1 6-6l.31.008ZM6 1.4a4.599 4.599 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2Z',
    }),
  );
});
playCircleSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var playCircle = {
  category: 'icon',
  colorable: true,
  name: 'playCircle',
  svg: playCircleSvg,
};
